import { makeActionCreator } from '../../config/store/utils'
import { getSectorBuyers } from '../../services/sectors'

const RANKING_DICTIONARY = {
  amount: 'rankingAmount',
  oc: 'rankingOC'
}

export const GET_SECTOR_BUYERS = 'GET_SECTOR_BUYERS'
export const GET_SECTOR_BUYERS_ERROR = 'GET_SECTOR_BUYERS_ERROR'
export const GET_SECTOR_BUYERS_SUCCESS = 'GET_SECTOR_BUYERS_SUCCESS'
export const onGetSectorBuyers = makeActionCreator(GET_SECTOR_BUYERS)
export const onGetSectorBuyersError = makeActionCreator(GET_SECTOR_BUYERS_ERROR, 'payload')
export const onGetSectorBuyersSuccess = makeActionCreator(GET_SECTOR_BUYERS_SUCCESS, 'payload')
export const onGetSectorBuyersThunk = payload => async dispatch => {
  dispatch(onGetSectorBuyers())

  try {
    const { data } = await getSectorBuyers({
      mechanismId: payload.mechanismId,
      order: payload.order,
      sectorId: payload.id,
      year: payload.year
    })
    const enhancedData = data.payload?.map(item => ({
      amount: item.purchaseAmountCLP,
      amountUSD: item.purchaseAmountUSD,
      id: item.entCode,
      name: item.name,
      orders: item.quantityOC,
      ranking: item[RANKING_DICTIONARY[payload.order]] || null
    }))
    const csv = [
      ['Nombre proveedor', 'N° de órdenes de compra', 'Monto transado', 'Monto transado ($USD)'],
      ...enhancedData.map(datum => [datum.name, datum.orders, datum.amount, datum.amountUSD])
    ]

    return dispatch(onGetSectorBuyersSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetSectorBuyersError({ error }))
  }
}
